// export const URL = "http://localhost:8000/"
// export const THIS_URL = "http://localhost:3000/"

export const URL = "https://api-site.ontest.com.br/"
export const THIS_URL = "https://www.ontest.com.br/"

export const API_URL = URL + "api/";
export const STORAGE_URL = URL + "storage/";